const options = {
  0: "translate-x-0",
  "1/2": "translate-x-1/2 transform",
  "-1/2": "-translate-x-1/2 transform",
};

export default function getTranslateX(value) {
  return options[value];
}
